module.exports = __webpack_public_path__ + "img/logo.f839038d.png";